import React, { ReactElement } from 'react';
import logo from 'assets/img/logo.png';
import useStyles from './loginForm.styles';
import { useForm } from 'react-hook-form';
import useUser, { LoginRequest } from 'hooks/useUser';

import { Container, CssBaseline, Typography, TextField, Button, CircularProgress } from '@material-ui/core';
import ListOfErrors from 'components/molecules/Form/ListOfErrors';

export default function LoginForm(): ReactElement {
  const { handleSubmit, register, errors } = useForm<LoginRequest>();
  const { login, isLoading, hasLoginError } = useUser();
  const classes = useStyles();

  const onSubmit = async (data: LoginRequest) => {
    login(data);
  };

  return (
    <Container component="main" maxWidth="xs" style={{ backgroundColor: 'white' }}>
      <CssBaseline />
      <div className={classes.paper}>
        <img src={logo} className="App-logo" alt="logo" width="400" />
        <Typography component="h1" variant="h5" style={{ marginTop: 40 }}>
          Inicia sesión para continuar
        </Typography>
        {hasLoginError && <ListOfErrors errors={['El usuario y/o la contraseña no son válidos.']} />}
        <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Usuario"
            name="username"
            autoComplete="username"
            autoFocus
            disabled={isLoading}
            inputRef={register<HTMLInputElement>({
              required: true
            })}
            error={errors.username ? true : false}
            helperText={errors.username && errors.username.message}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            id="password"
            inputRef={register<HTMLInputElement>({ required: true })}
            disabled={isLoading}
            error={errors.password ? true : false}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Aceptar'}
          </Button>
        </form>
      </div>
    </Container>
  );
}
